// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { readAuthSafe } from "../utils/auth";
import { PP_USER_READY_EVENT } from "../utils/userEvents";

export default function ProtectedRoute({ children }) {
  const [, setAuthVersion] = useState(0);
  useEffect(() => {
    const handleAuthChange = () => setAuthVersion((version) => version + 1);
    window.addEventListener(PP_USER_READY_EVENT, handleAuthChange);
    return () => window.removeEventListener(PP_USER_READY_EVENT, handleAuthChange);
  }, []);
  const location = useLocation();
  const auth = readAuthSafe();

  if (!auth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

